const essays = [
    {
        title: 'The Epistemic Sedimentation of Coding',
        fileName: 'essay1.md',
        citations: 'essay1c.md',
        prompts: 'essay1p.md'
    }
];

export default essays;